import { createResourceListQuery } from "queries";
import types from "resources/types";

export const TermsOfServiceQuery = () =>
  createResourceListQuery(types.TERMS_OF_SERVICE, {
    url: "/api/v2/terms_of_service/",
  });
